import React, { useRef } from "react";
import LzXButton from "@lz-components/forms/Button";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PublishIcon from '@mui/icons-material/Publish';
import PrintIcon from '@mui/icons-material/Print';
import { lzFGetAppRouteFullUrl, useLzFShowErrorMessage } from "@lz-services/Utils";
import SalesInvoiceModel from "./sales-invoice.model";

const SalesInvoiceImportExportComponent = (props) => {

    const refUploadInputField = useRef(null);

    const lzFShowErrorMessage = useLzFShowErrorMessage();

    const handleImportClick = () => {
        if (refUploadInputField.current) {
            refUploadInputField.current.click();
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    props.onChange(
                        new SalesInvoiceModel(
                            Object.assign(
                                {},
                                props.data,
                                JSON.parse(
                                    e.target.result
                                )
                            )
                        )
                    );
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    lzFShowErrorMessage('Invalid json file.');
                }
            };

            reader.readAsText(file); // Read the file content as text
        }
    };

    const handlePrint = () => {
        window.open(lzFGetAppRouteFullUrl('/content/sales-invoices/' + props.data.id + '/print'), '_blank');
    };

    return (
        <React.Fragment>

            {props.data.id > 0 &&
                <a
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(props.data.getJson())}`}
                    download={props.data.invoice_no + '.json'}>
                    <LzXButton info size="small" variant="text">
                        <FileDownloadIcon /> Export JSON
                    </LzXButton>
                </a>
            }

            <input ref={refUploadInputField} type="file" accept=".json" onChange={handleFileChange} style={{ display: 'none' }} />
            {!props.data.is_fbr_registered &&
                <LzXButton info size="small" variant="text" style={{ marginLeft: 21 }} onClick={handleImportClick}>
                    <PublishIcon /> Import JSON
                </LzXButton>
            }

            {props.data.id > 0 &&
                <LzXButton info size="small" variant="text" style={{ marginLeft: 21 }} onClick={handlePrint}>
                    <PrintIcon /> Print Invoice
                </LzXButton>
            }

        </React.Fragment>
    );

};

export default SalesInvoiceImportExportComponent;
